import {
    GLOBAL_INFO,
    RESET_GLOBAL_INFO,
} from './GlobalActionTypes'

export const initialGlobalState = () => ({
    info: null,
});

const global = (state = initialGlobalState(), action) => {
    switch (action.type) {
        case GLOBAL_INFO:
            return {
                ...state,
                info: action.message,
            }
        case RESET_GLOBAL_INFO:
            return {
                ...state,
                info: null,
            }
        default:
            return state;
    }
}
export default global;